import { Component, OnInit } from '@angular/core';
import { AppData } from '../../../services';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    constructor(public appData: AppData) {}

    ngOnInit() {}
}
